@if (viewMode === ViewModes.Grid) {
  <div
    infiniteScroll
    [infiniteScrollDistance]="5"
    [infiniteScrollThrottle]="50"
    [infiniteScrollDisabled]="isMaxProducts || isLastPage || isEmpty"
    (scrolled)="scrollPage(model?.pagination?.currentPage + 1)"
    >
    <div class="row">
      @for (product of model?.products; track product) {
        <app-efa-product-grid-item
          [product]="product"
          [id]="getProductCodeUrlEncoded(product.code)"
          [price]="getPrice(prices, product.code)"
          [currentPage]="model?.pagination?.currentPage"
          [backUrl]="backUrl"
          class="col-12 col-sm-6 col-md-4"
        ></app-efa-product-grid-item>
      }
    </div>
    <div
      [className]="
        !isLastPage && model?.pagination?.currentPage > 0
          ? 'cx-double-btn-container grid-btn-padding'
          : 'cx-single-btn-container grid-btn-padding'
      "
      >
      @if (
        (isMaxProducts || isLastPage) && model?.pagination?.currentPage > 0
        ) {
        <div
          (click)="scrollToTop()"
          class="btn btn-block btn-action"
          >
          {{ 'productList.backToTopBtn' | cxTranslate }}
        </div>
      }
      @if (isMaxProducts && !isLastPage) {
        <div
          (click)="loadNextPage(model?.pagination?.currentPage + 1)"
          class="btn btn-block btn-action align-btn"
          >
          {{ 'productList.showMoreBtn' | cxTranslate }}
        </div>
      }
    </div>
    @if (appendProducts) {
      <div class="cx-spinner">
        <cx-spinner></cx-spinner>
      </div>
    }
  </div>
}

@if (viewMode === ViewModes.List) {
  <div
    infiniteScroll
    [infiniteScrollDistance]="3"
    [infiniteScrollThrottle]="50"
    [infiniteScrollDisabled]="isMaxProducts || isLastPage || isEmpty"
    (scrolled)="scrollPage(model?.pagination?.currentPage + 1)"
    >
    @for (product of model?.products; track product) {
      <app-efa-product-list-item
        [product]="product"
        [price]="getPrice(prices, product.code)"
        [id]="getProductCodeUrlEncoded(product.code)"
        [currentPage]="model?.pagination?.currentPage"
        [backUrl]="backUrl"
        class="cx-product-search-list"
      ></app-efa-product-list-item>
    }
    <div
      [className]="
        !isLastPage && model?.pagination?.currentPage > 0
          ? 'cx-double-btn-container'
          : 'cx-single-btn-container'
      "
      >
      @if (
        (isMaxProducts || isLastPage) && model?.pagination?.currentPage > 0
        ) {
        <div
          (click)="scrollToTop()"
          class="btn btn-block btn-action"
          >
          {{ 'productList.backToTopBtn' | cxTranslate }}
        </div>
      }
      @if (isMaxProducts && !isLastPage) {
        <div
          (click)="loadNextPage(model?.pagination?.currentPage + 1)"
          class="btn btn-block btn-action align-btn"
          >
          {{ 'productList.showMoreBtn' | cxTranslate }}
        </div>
      }
    </div>
    @if (appendProducts) {
      <div class="cx-spinner">
        <cx-spinner></cx-spinner>
      </div>
    }
  </div>
}
